import Login from 'layouts/admin/login.js';
import ForgotPassword from 'layouts/admin/forgotPassword.js';
import RecoverPassword from 'layouts/admin/RecoverPassword.js';
import EditTemplates from 'layouts/settings/EditTemplates.js';
import ProtectedRoute from "routes/protectedRoutes.js";
import ViewProfile from 'layouts/admin/ViewProfile.js';
import InfoLog from 'layouts/infolog/InfoLog';
const AdminRoutes = [
  {
    route: "/admin/login",
    key: "login-admin",
    component: <ProtectedRoute check="login"><Login /></ProtectedRoute>
  },
  {
    route: "/admin/forgotpassword",
    key: "ForgotPassword-admin",
    component: <ProtectedRoute check="login"><ForgotPassword /></ProtectedRoute>
  },
  {
    route: "/admin/confirmPassword",
    key: "RecoverPassword-admin",
    component: <ProtectedRoute check="login"><RecoverPassword /></ProtectedRoute>
  },  
  {
    route: "/admin/viewTemplate/:id",
    key: "EditTemplates-admin",
    component: <ProtectedRoute check="logout"> <EditTemplates /></ProtectedRoute>
  },  
  {
    route: "/admin/infoLog/:pageNo",
    key: "Log-information",
    component: <ProtectedRoute check="logout"> <InfoLog /></ProtectedRoute>
  }

];

export default AdminRoutes;
 
